import React from 'react';
import { Breadcrumb } from 'antd';
import { RightOutlined } from '@ant-design/icons';

export type PathT = {
  label: string,
  value?: string,
};

export type AlumlyBreadCrumbPropT = {
  path: PathT[],
};

const ACTIVE_COLOR = '#52a47c';
const LINK_COLOR = '#1f2a44';

const AlumlyBreadCrumb: React.FC<AlumlyBreadCrumbPropT> = (props: AlumlyBreadCrumbPropT) => {
  const {
    path,
  } = props;

  const totalPathElement = path.length;

  const items = path.map((el, idx) => {
    const isLastElement = idx === totalPathElement - 1;
    if (isLastElement) {
      return {
        key: `breadcrumb-${el.label}`,
        title: (
          <span style={{ color: ACTIVE_COLOR, fontWeight: 700 }}>{el.label}</span>
        ),
      };
    }
    return {
      key: `breadcrumb-${el.label}`,
      title: el?.value
        ? <a href={el.value} style={{ color: LINK_COLOR }}>{el.label}</a>
        : <span style={{ color: LINK_COLOR }}>{el.label}</span>,
    };
  });

  return (
    <div style={{ paddingBottom: 16 }}>
      <Breadcrumb
        separator={<RightOutlined style={{ fontSize: 12 }} />}
        items={items}
      />
    </div>
  );
};

export default AlumlyBreadCrumb;
